import { RouterLocationState, useTabContext } from "@/components/layout/TabContext";

export const useTabLocationState = <T extends RouterLocationState = RouterLocationState>() => {
  const { routerLocationState } = useTabContext();
  return routerLocationState as T;
};
